import axios from 'axios';
import { IUserShortCollection } from 'common/models';
import {
  IInventoryAction,
  IInventoryActionCollectionDto,
  IInventoryActionCreatePayload,
  IInventoryActionDeletePayload,
  IInventoryActionListPayload,
  IInventoryActionUpdatePayload,
  IInventoryActionListUsersParams,
} from 'entities/InventoryAction/InventoryAction.models';

const basePath = 'inventory-action';

export const inventoryActionTransport = {
  get: (payload: IInventoryActionListPayload): Promise<IInventoryActionCollectionDto> => axios.post(`${basePath}/list`, payload),
  getById: (id: number): Promise<IInventoryAction> => axios.get(`inventory-action/${id}`),
  create: (payload: IInventoryActionCreatePayload): Promise<IInventoryAction> => axios.post(`${basePath}`, payload),
  update: (payload: IInventoryActionUpdatePayload): Promise<IInventoryAction> => axios.patch(`${basePath}`, payload),
  delete: (payload: IInventoryActionDeletePayload): Promise<IInventoryActionCollectionDto> =>
    axios.delete(`${basePath}`, { data: payload }),
  getUsers: (params: IInventoryActionListUsersParams): Promise<IUserShortCollection> =>
    axios.get(`${basePath}/users`, { params }),
};
